import React from 'react';

import { IconButton, styled } from '@mui/material';
import PropTypes from 'prop-types';

const IconButton_Arrow = styled(IconButton, {
  shouldForwardProp: prop =>
    prop !== 'currentSlide' && prop !== 'slideCount' && prop !== 'slidesToShow',
})({});

const CarouselArrowButton = ({ icon, ...rest }) => (
  <IconButton_Arrow {...rest}>{icon}</IconButton_Arrow>
);

CarouselArrowButton.propTypes = {
  icon: PropTypes.node.isRequired,
};

export default CarouselArrowButton;
